import {
  evaluateObjectFunctions,
  getThemeData,
  isDev,
  removeEmptyValues,
} from "~/utils";
import type { IServerResponse, IData } from "~/interfaces";
import { MAX_REQUESTS_TRY } from "~/utils/constants"

export default defineNuxtPlugin(() => {
  return {
    provide: {
      send: async ({ payload, method = "PUT" }: any): Promise<IServerResponse> => {
        
        const body = evaluateObjectFunctions(payload);
        const data: IData = getThemeData();
        body.orderID = getStateValue("orderID");
        body.envType = getStateValue("envType");
        body.envName = getStateValue("envName");
        body.query_string = getStateValue("urlVars");
        if (body.query_string.orderID) delete body.query_string.orderID

        //Verify if is necessary to remove empty values from the object
        const objWithoutNulls = removeEmptyValues(body);

        if (isDev()) {
          return new Promise(async (resolve) => {
              console.log("Request body", objWithoutNulls);
              resolve({success: true, orderID: body.orderID})
          });
        }

        return new Promise(async (resolve, reject) => {

          let success = false, tryTimes = 0;
          updateStateValue("sendingServerRequest", true)
          while (success === false && tryTimes < MAX_REQUESTS_TRY) {
            tryTimes++;

            try {
              const response = await $fetch<IServerResponse>(
                data.endpoints.server as string, 
                { method, body: objWithoutNulls }
              );
              if (response.success === true) {
                success = true;
                updateStateValue("loadingModal", false)
                updateStateValue("sendingServerRequest", false)
                resolve(response)
                return;
              }
              throw new Error("Fetch failed, message: " + response as string)          
            } catch(e) {
              updateStateValue("loadingModal", true)
            };
          }

          updateStateValue("loadingModal", false)
          updateStateValue("errorModal", true)
          updateStateValue("sendingServerRequest", false)
          reject({success: false})
        })

      },
    },
  };
});
